export default __webpack_public_path__ + "static/media/ic_language24.ceaebef6.svg";